import $ from 'jquery';
import {ACC_COOCKIE} from './Params'
import Cookies from 'js-cookie';
import { state } from './State';


export function isVisible(elem) {
    return elem.is(':visible')
};
export function hasParentClass(element, classname) {
    if(element.className.split(' ').indexOf(classname) >= 0) {
        return true;
    }
    return element.parentNode && hasParentClass(element.parentNode, classname);
};
export function hasParentId(element, idname) {
    if(element.id == idname) {
        return true;
    }
    return element.parentNode && hasParentId(element.parentNode, idname);
};
export function insertAfter(el, ref) {
    ref.parentNode.insertBefore(el, ref.nextSibling);
};

export function isEmpty(any) {
    return any === undefined || any === null || !isEmpty(any.length) && any.length === 0 || typeof any === 'object' && Object.keys(any).length === 0;

};

export function foreachCb(obj, cb) {
    if(isEmpty(obj)) {
        return;
    }
    if(typeof(cb) !== 'function') {
        return;
    }
    for(var i in obj) {
        if(!obj.hasOwnProperty(i)) {
            continue;
        }
        cb(i, obj[i]);
    }
};

export function getStyleValue(element) {
    return getComputedStyle(element, null);
};


export function ensureAttribute(attrName, element, fromComputed) {
    var attr, key, value;
    key = 'acc-' + attrName;
    var styles = fromComputed ? getStyleValue(element) : element.style;
    value = styles[attrName];
    attr = element.attributes.getNamedItem(key);
    if(attr == null) {
        element.setAttribute(key, value);
    }
};
export function fromAttribute(attrName, element) {
    var attr, key;
    key = 'acc-' + attrName;
    attr = element.attributes.getNamedItem(key);
    if(attr == null) {
        element.style[attrName] = "";
    }
    else {
        element.style[attrName] = attr.value;
        element.removeAttribute(key);
    }
};

export function hasChildClass(parent,classname) {
    var exist = false;
    for (var i = 0; i < parent.childNodes.length; i++) {
        if (parent.childNodes[i].className==classname) {
            exist = true;
            break;
        }
    }
    return exist;
};

export function updateState(key,val,active){
    if(active){
        state.info[key] = val
        state[key] = val
    }
    else{
        delete state.info[key];
        state[key] = false
    }
};
export function updateBodyClass(classname,active){
    $('body').toggleClass(classname,active)
};
export function saveToCoockie() {
    Cookies.set(ACC_COOCKIE, JSON.stringify(state.info), { expires: 1, path: '/' });
};

export function getCookie(name) {
    let c = Cookies.get(name);
    if(isEmpty(c)){
        return false
    }
    let result = JSON.parse(c);
    if(isEmpty(result)){
        return false
    }
    return result
}

export function deleteCookie(name){
    Cookies.remove(name,{ path: '/' });
};

export function updateElmStatus(elem, ischanged) {
    ischanged ? elem.classList.add('active') : elem.classList.remove('active');
};

export function getComputedStyle(element) {
    return element.style;
};

export function updateButtonState(btn,status){
    btn.toggleClass('active',status)
    btn.attr('aria-selected',status ? 'true' : 'false')

}

export function acc(key){
    return window.acc[key]
}

export function mediaPath(icon){
    return window.acc['mediaPath'] + icon;
}


export function locale(str){
    return window.acc['locale'][str];
}

export function root(){
    return window.acc['root'];
}


export function get_first_tabindex(elem) {

    if (elem.attr('tabindex') === '0') {
        return elem;
    }
    let elems = $('*[tabindex=0],a,button,input,textarea', elem).filter((i, el) => $(el).is(':visible') && $(el).attr('tabindex') !== "-1");
    if (isEmpty(elems)) {
        elems = $('*[tabindex=0],a,button,input,textarea', elem);
    }
    return elems.first();

}

export function get_last_tabindex(elem, add = true) {
    let elems = $('*[tabindex],a,button,input,textarea', elem).filter((i, el) => $(el).is(':visible') && $(el).attr('tabindex') !== "-1");
    if (isEmpty(elems) || elems.length === 1) {
        if (!add) {
            return null;
        }
        elem.append($(`<span class="last-tabindex" tabindex="0" data-for="${elem.attr('id')}">`));
        elems = $('*[tabindex],a,button,input,textarea', elem);
    }
    if (elem.find('.end_focus').length > 0) {
        /*fix fancybox focus bug...*/
        return elems.eq(elems.length - 1);
    }
    return elems.last();
}

export function loopFocus(elem, last = false, target = false) {
    if (elem.hasClass('fancybox-inner')) {
        elem.append($('<span class="end_focus" tabindex="0">'));
    }
    const lastElem = last ? last : get_last_tabindex(elem);
    const firstElem = get_first_tabindex(elem);

    firstElem.keydown((e) => {
        e.stopPropagation();
        const keyCode = e.keyCode || e.which;
        if (e.shiftKey && keyCode === 9) {
            lastElem.focus();
            e.preventDefault();
        }
    });

    lastElem.keydown((e) => {
        const keyCode = e.keyCode || e.which;
        e.stopPropagation();
        if (keyCode === 9 && !e.shiftKey) {
            const firstFocus = target ? target : get_first_tabindex(elem);
            firstFocus.focus();
            e.preventDefault();
        }
    });
}



export function load_recaptcha() {

    let tag = document.createElement("script");
        tag.setAttribute("src", "https://www.google.com/recaptcha/api.js?onload=onloadRecaptchaCallback&render=explicit");
        document.body.appendChild(tag);

}

export function register_outline_toggle() {
    /**
     * prevent outline styles from displaying  while using a mouse to navigate but show them when using a keyboard.
     */
    $('body').addClass('using-mouse');
    $('body').on('mousedown', () => {
        if(!state.keyboardNav) {
            $('body').addClass('using-mouse');
        }
    });
    $('body').on('keyup', () => {
        $('body').removeClass('using-mouse');
    });

}
